import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { BorderRadiusThemeProps } from 'shared/types/Theme';

import { BorderRadiusPanel } from '@/components/Theme/BorderRadiusPanel';
import { ResetButton } from '@/components/Theme/ResetButton';
import { TooltipConfigProps } from '@/utils/tiptap/extensions/Tooltip/components/TooltipConfig';
import { FormControl } from '@/widgets/_components/FormControl';

export function Corners(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, resolvedStyles, onUpdateStyle } = props;
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const setCornerRadius = useCallback(
    (newCornerRadius: Partial<BorderRadiusThemeProps>) => {
      onUpdateStyle({ cornerRadius: { ...resolvedStyles.cornerRadius, ...newCornerRadius } });
    },
    [onUpdateStyle, resolvedStyles.cornerRadius]
  );

  return (
    <FormControl title={t('cornerRadius')}>
      <BorderRadiusPanel
        label={t('cornerRadius')}
        setBorderRadius={setCornerRadius}
        borderRadius={resolvedStyles.cornerRadius}
        ResetButton={styles.cornerRadius && <ResetButton onClick={() => onRemoveStyle('cornerRadius')} />}
      />
    </FormControl>
  );
}
